import Button from "components/button"
import './styles.scss';
import DATA from 'utils/data.json';

const RegisterShort = () => {
    return (
        <div className="register-short container">
            <p className="title">Foundations of Deep Learning</p>
            <Button className="btn" href={DATA['form']} content="Đăng ký ngay"></Button>
        </div>
    )
}

export default RegisterShort